import { buildImagePath } from '../../../JobComponents/Company/Image/logo';

const logoTransforms = { default: 'c_lpad,f_auto,q_auto,w_75,h_75' };

export const buildCompanyLogoSrc = (cloudinaryId) =>
    buildImagePath(
        cloudinaryId || '/v1/icons/company_2x.png',
        'default',
        logoTransforms
    );
